/*مذهبی*/
import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={83.744}
      height={96.91}
      viewBox="0 0 83.744 96.91"
      {...props}
    >
      <g data-name="Group 349" fillRule="evenodd">
        <path
          data-name="Path 7552"
          d="M29.204 86.266L11.279 69.548l-1.844-1.72a4.484 4.484 0 10-6.117 6.559l20.83 19.428a4.485 4.485 0 106.117-6.559z"
          fill="#ffc144"
        />
        <path
          data-name="Path 7553"
          d="M20.656 63.421l-9.377 6.127 17.925 16.718c19.47-10.9 9.969-29.828 10.8-39.113.176-1.982 1.495-14 1.671-15.986a3.785 3.785 0 00-3.412-4.1 3.013 3.013 0 00-1.537.247l4.597-19.812c1.294-6.044-5.678-7.614-7.383-2.715-1.134 3.367-7.365 18.517-11.131 28.947-2.709 7.5-3.071 9.771-2.708 17.672z"
          fill="#f5c6af"
        />
        <path
          data-name="Path 7554"
          d="M43.747 47.153c.826 9.285-8.675 28.212 10.795 39.114l17.925-16.718-9.377-6.127.552-12.011c.363-7.9 0-10.169-2.708-17.672-3.766-10.43-10-25.58-11.131-28.947-1.705-4.9-8.678-3.329-7.383 2.715l4.606 19.808a3.015 3.015 0 00-1.537-.247 3.785 3.785 0 00-3.412 4.1c.175 1.981 1.494 14.002 1.67 15.985z"
          fill="#f5c6af"
        />
        <path
          data-name="Path 7555"
          d="M72.467 69.548L54.542 86.266l-1.061.989a4.485 4.485 0 006.117 6.559l20.83-19.428a4.484 4.484 0 10-6.117-6.559z"
          fill="#ffc144"
        />
      </g>
      <path
        data-name="Path 7556"
        d="M82.034 66.757a6.385 6.385 0 00-9.014-.314l-.76.709-7.233-4.724.5-10.931c.371-8.082-.024-10.661-2.819-18.4-2.163-5.99-5.114-13.475-7.485-19.49-1.7-4.3-3.162-8.022-3.633-9.418l-.006-.018A5.779 5.779 0 0044.537.206a5.612 5.612 0 00-2.664 1.676A5.611 5.611 0 0039.209.206a5.78 5.78 0 00-7.053 3.964l-.006.018c-.377 1.118-1.4 3.757-2.46 6.441a1.893 1.893 0 003.523 1.385c1.237-3.147 2.139-5.475 2.521-6.609a2.036 2.036 0 012.455-1.554c.9.253 1.715 1.238 1.29 3.244l-4.421 19.012a8.314 8.314 0 00-2.63 3.657 99.124 99.124 0 00-5.057 15.383 1.893 1.893 0 103.692.835 95.171 95.171 0 014.864-14.761c.99-2.373 1.844-2.3 2.165-2.267A1.882 1.882 0 0139.784 31c-.087.975-.466 4.526-.832 7.961-.385 3.609-.749 7.017-.839 8.025a40.271 40.271 0 00.676 8.666c1.336 9.225 2.988 20.64-9.328 28.267L14.336 69.811l7.355-4.805a1.894 1.894 0 00.856-1.672l-.552-12.011c-.349-7.6-.033-9.655 2.6-16.942a383.672 383.672 0 012.429-6.517 1.893 1.893 0 00-3.537-1.349c-.96 2.516-1.76 4.668-2.46 6.585-2.795 7.74-3.19 10.32-2.819 18.4l.5 10.931-7.231 4.724-.76-.708a6.377 6.377 0 10-8.7 9.327L22.855 95.2a6.377 6.377 0 009.393-8.568 23.6 23.6 0 009.624-11.548 23.6 23.6 0 009.625 11.547 6.378 6.378 0 009.392 8.569l20.83-19.428a6.385 6.385 0 00.315-9.015zM29.101 92.3a2.594 2.594 0 01-3.663.128L4.608 73a2.592 2.592 0 013.535-3.79l20.83 19.428a2.591 2.591 0 01.128 3.663zm10.034-67.009l2.738-11.776 2.738 11.776a5.627 5.627 0 00-2.738 1.487 5.626 5.626 0 00-2.738-1.487zm2.738 22.186a15.907 15.907 0 010 2.063 15.941 15.941 0 010-2.063zm3.084 8.173a40.273 40.273 0 00.676-8.666c-.09-1.008-.454-4.416-.839-8.025-.367-3.435-.746-6.987-.832-7.961a1.882 1.882 0 011.7-2.045c.322-.028 1.175-.106 2.165 2.267a95.183 95.183 0 014.859 14.761 1.893 1.893 0 103.692-.835 99.113 99.113 0 00-5.061-15.383 8.311 8.311 0 00-2.63-3.657L44.267 7.1c-.425-2.006.387-2.991 1.29-3.244a2.037 2.037 0 012.455 1.555c.5 1.493 1.913 5.067 3.7 9.588 2.362 5.991 5.3 13.448 7.446 19.387 2.631 7.286 2.947 9.345 2.6 16.942l-.552 12.011a1.893 1.893 0 00.856 1.672l7.355 4.805-15.132 14.101C41.969 76.29 43.621 64.876 44.957 55.65zM79.138 73l-20.83 19.43a2.592 2.592 0 11-3.535-3.79l20.83-19.428A2.592 2.592 0 0179.138 73z"
      />
      <path
        data-name="Path 7557"
        d="M27.585 20.989a1.891 1.891 0 002.485-.994 1.893 1.893 0 10-2.486 1z"
      />
    </svg>
  )
}

const MemoSvgComponent = React.memo(SvgComponent)
export default MemoSvgComponent
